'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';

// Import lib files
import { useEnvContext } from '@/context/envContext';
interface blurBannerProps {
  resId: string;
  primarySiteName: string;
  fallBackImage: string;
}
const BannerBlur = ({
  resId,
  fallBackImage
}: blurBannerProps) => {
  // Find the correct image name for fallback from primarySiteName
  //  const fallbackImagePath = selectFallback(
  //   primarySiteName ? primarySiteName : 'genericMulti',
  //  );

  const {
    cdnEnv: env
  } = useEnvContext();
  const src = `${env}/bitpipe/covers/${resId}_lg.jpg`;
  const [imgSrc, setImgSrc] = useState(src);
  useEffect(() => {
    setImgSrc(src);
  }, [src]);
  return <div className={'parent-blur-background'} aria-hidden={'true'} data-sentry-component="BannerBlur" data-sentry-source-file="BannerBlur.tsx">
   <Image className={'design-background'} src={imgSrc} alt={''} data-bdd={'blur-banner'} priority={true} width={1400} height={50} style={{
      width: '100%',
      height: 'auto'
    }} object-fit={'cover'} placeholder={'empty'} onError={() => {
      setImgSrc(fallBackImage);
    }} unoptimized={true} data-sentry-element="Image" data-sentry-source-file="BannerBlur.tsx" />
   <div className={'mask'}></div>
  </div>;
};
export default BannerBlur;